import React from "react";
import { FooterApp } from "../FooterApp";
import { TheHeader, TheSidebar } from "./index";
import { useIsMobile } from "@hooks/useIsMobile";

const TheLayout = ({ children }) => {
    const isMobile = useIsMobile();
    return (
        <div className="c-app c-default-layout">
            <TheSidebar />
            <div className="c-wrapper">
                <TheHeader />
                <div className="c-body">
                    <div
                        className={`mt-3 mb-5 ${
                            !isMobile ? "container-fluid" : ""
                        }`}
                    >
                        {children}
                    </div>
                </div>
            </div>
            <FooterApp />
        </div>
    );
};

export default TheLayout;
